// ABOUTME: Root layout component providing app shell structure.
// ABOUTME: Wraps page content with toolbar.

import { Outlet } from 'react-router-dom';
import { Toolbar } from './Toolbar';

export function RootLayout() {
  return (
    <div className="relative w-full h-screen overflow-hidden bg-surface-50 flex selection:bg-primary-500/30 selection:text-surface-900">
      <div className="relative h-full flex-1 flex flex-col overflow-hidden bg-surface-50 z-10">
        {/* Top Toolbar */}
        <Toolbar />

        {/* Main Content Area */}
        <div className="flex-1 overflow-hidden">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
